/**
 * @author : Abhishek N.
 * @description : Layout component serves as a common layout structure for different pages. It includes a route outlet to render child routes and displays the main footer.Additionally, it uses the useCanvasDetection hook to determine if a canvas is present.
 *
 */

import { Outlet } from "react-router-dom";

/**
 
 * @returns {JSX.Element} The JSX for the Layout component.
 */
const Layout = () => {

  return (
    <div>
      {/* Render the child routes within the Outlet component. */}
      <Outlet />
    </div>
  );
};

export default Layout;
